<template>
<div>
  <div class="label-resumo">
    Resumo da compra
  </div>
  <div style="margin-top: 10px; font-size: 13px">
    <div class="preco-container">
      <div style="width: 49%">
        <strong style="color: #464646">Valor da reserva:</strong>
      </div>
      <div style="width: 50%; text-align: right">
        <span>{{ formatMoney(total) }}</span>
      </div>
    </div>
    <div
      v-if="cobrarTaxa"
      class="preco-container">
      <div style="width: 49%; position: relative">
        <strong style="color: #464646">Taxas</strong>
        <span
          v-show="tooltip"
          class="tooltip-container">
          <span class="tooltip-text">
            As taxas incluem
            <strong>{{ formatMoney(taxa) }}</strong>
            de serviço, para manutenção da plataforma e operação.
          </span>
        </span>
        <span
          class="info-container ml-1 mr-1"
          @mouseenter="tooltip = true"
          @mouseleave="tooltip = false">
          <b><i
            class="fas fa-question"
            style="padding: 3px; color: #fff" /></b>
        </span>
        <strong>:</strong>
      </div>

      <div style="width: 50%; text-align: right">
        <span>{{ formatMoney(taxa) }}</span>
      </div>
    </div>
    <div class="preco-container">
      <div style="width: 49%">
        <strong style="color: #464646">Opcionais:</strong>
      </div>
      <div style="width: 50%; text-align: right">
        <span>{{ formatMoney(opcionais) }}</span>
      </div>
    </div>
    <div
      v-show="desconto > 0"
      class="preco-container">
      <div style="width: 49%">
        <strong style="color: #464646">Desconto do período:</strong>
      </div>
      <div style="width: 50%; text-align: right">
        <span>-{{ formatMoney(desconto) }}</span>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  components: {},
  props: {
    total: {
      type: Number,
      default: () => 0,
      required: true
    },
    desconto: {
      type: Number,
      default: () => 0,
      required: true
    },
    opcionais: {
      type: Number,
      default: () => 0,
      required: true
    },
    moeda: {
      type: String,
      default: () => 'BRL',
      required: true
    },
    cobrarTaxa: {
      type: Boolean,
      default: () => false
    },
    taxa: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return { tooltip: false };
  },
  methods: {
    formatMoney(price) {
      let locale = 'pt-Br';

      if (this.$props.moeda === 'USD') {
        locale = 'en-US';
      }

      if (price <= 0 || price === null) {
        return Number(0.0).toLocaleString(locale, {
          style: 'currency',
          currency: this.$props.moeda
        });
      }
      return Number(price).toLocaleString(locale, {
        style: 'currency',
        currency: this.$props.moeda
      });
    },
  }
};
</script>

<style scoped>
.label-resumo {
  padding: 5px;
  display: inline-block;
  background-color: #efefef;
  color: #464646;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.preco-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
}

.tooltip-container {
  display: inline-block;
  background-color: #1c1f27;
  color: white;
  font-size: 14px;
  padding: 20px;
  border-radius: 8px;
  max-width: 290px;
  position: absolute;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  bottom: 26px;
  right: -15px;
}

.tooltip-container::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 20%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #1c1f27;
}

.tooltip-text strong {
  color: #ffffff;
  font-weight: bold;
}

.info-container {
  font-size: 8px;
  border: 1px solid #4f70e5;
  border-radius: 50%;
  background-color: #4f70e5;
  vertical-align: middle;
  margin-right: -3px;
}
</style>
